// Shared alphabetical (Hebrew-aware) sorting for patient pickers.
// Returns a NEW array; never mutates the input.

const patientDisplayName = (p) =>
  `${p?.firstName || ""} ${p?.lastName || ""}`.trim() || p?.fullName || "";

export const comparePatientsByName = (a, b) =>
  patientDisplayName(a).localeCompare(patientDisplayName(b), "he");

export const sortPatientsByName = (patients = []) =>
  [...patients].sort(comparePatientsByName);
